<template>
	<div>
		<vs-prompt :active.sync="active" title="Activate message" accept-text="Send now" v-on:accept="$emit('accept')">

			<vs-input name="mailTo" label-placeholder="Email address" v-model="result.email" class="w-full mb-6" />


			<quill-editor class="editor1" v-model="mailMessage" :options="editorOption" />
			<div class="px-4 pt-1 pb-1 fake-editor">
				<div class="vx-row">
					<div class="vx-col lg:w-1/2 w-full">
						<vx-card v-if="aiLoading1" class="mb-0 h-100">
							<div class="flex items-center my-6 py-6">
        						<img src="/logo-animation-beta1.5.svg" alt="Logo" height="100" width="100" class="mx-auto">
								<div>Artificial intelligence loading</div>
							</div>
						</vx-card>
						<vx-card v-else class="mb-0 h-100">
							<div class="mb-4">
								<h5 class="mb-3 whitespace-nowrap truncate">
									4 Nights Bahamas
								</h5>
								<p class="text-dark-grey">Carnival Conquest</p>
								<p class="text-dark-grey">2022 April-21</p>
							</div>
							<div
								class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4"
							>
								<div class="flex items-center text-sm">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>Your preferred cruise line</span>
								</div>
								<div class="flex items-center">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>Great service on board</span>
								</div>
								<div class="flex items-center mb-4">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>Dinner is awesome</span>
								</div>
								<div class="flex items-center mb-3">
									<vs-progress
										:percent="95"
										color="primary"
									/>
									<span class="text-sm ml-4">95%</span>
								</div>
							</div>

							<div class="flex items-center justify-between">
								Interior<br />
								<span
									><span class="text-xl">$349&nbsp;</span>
									<span class="text-primary">-30%</span></span
								>
							</div>
						</vx-card>
					</div>
					<div class="vx-col lg:w-1/2">

						<vx-card v-if="aiLoading2" class="mb-0 h-100">
							<div class="flex items-center my-6 py-6">
        						<img src="/logo-animation-beta1.5.svg" alt="Logo" height="100" width="100" class="mx-auto">
								<div>Artificial intelligence loading</div>
							</div>
						</vx-card>
						<vx-card v-else class="mb-0 h-100">
							<div class="mb-4">
								<h5 class="mb-3 whitespace-nowrap truncate">
									4 Nights Western Caribbean
								</h5>
								<p class="text-dark-grey">Carnival Conquest</p>
								<p class="text-dark-grey">2022 April-22</p>
							</div>
							<div
								class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4"
							>
								<div class="flex items-center text-sm">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>Your preferred cruise line</span>
								</div>
								<div class="flex items-center">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>Service is best in class</span>
								</div>
								<div class="flex items-center mb-4">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>Plenty of onboard activities</span>
								</div>
								<div class="flex items-center mb-3">
									<vs-progress
										:percent="93"
										color="primary"
									/>
									<span class="text-sm ml-4">93%</span>
								</div>
							</div>

							<div class="flex items-center justify-between">
								Interior<br />
								<span
									><span class="text-xl">$369&nbsp;</span>
									<span class="text-primary">-12%</span></span
								>
							</div>
						</vx-card>
					</div>
				</div>

			</div>
			<quill-editor class="editor2" v-model="mailMessage2" :options="editorOption2" />
		</vs-prompt>
	</div>
</template>


<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

export default {
	data() {
		return {
			active: true,
			mailMessage: '<p>Hi '+this.result.firstname+',</p><p>I hope you are doing well.</p><p>We haven’t been in touch for a while and saw these offers and had to think of you:</p>',
			mailMessage2: '<p>Let me know what you think. Happy to chat about your preferences.</p><p>Best regards</p><p>Jennifer</p>',
			editorOption: {
				modules: {
				toolbar: [
					['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
					[{ 'header': 1 }, { 'header': 2 }],
					[{ 'list': 'ordered' }, { 'list': 'bullet' }],
					[{ 'font': [] }]
				]
				},
				placeholder: 'Message'
			},
			aiLoading1: true,
			aiLoading2: true,
			editorOption2:
			{
				modules: {
					"toolbar": false
				},
				placeholder: 'Message'
			},
		};
	},
	methods: {
        loadingTimer: function () {
            var v = this;
            setTimeout(function () {
                v.aiLoading1 = false;
            }, 1000);
            setTimeout(function () {
                v.aiLoading2 = false;
            }, 3000);
        }
	},
    mounted () {
      this.loadingTimer()
    },
	props: {
		result: {
			type: Object,
			required: true,
		},
	},
	components: {
	    quillEditor,

	}
};
</script>

<style lang="scss">
	.editor1 .ql-container.ql-snow {
		border-bottom: none;
	}
	.editor2 .ql-container.ql-snow {
		border-top: none;
	}
	.fake-editor {
		border-left: 1px solid #ccc;
		border-right: 1px solid #ccc;
	}
</style>
